import React from "react";
import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import { inlinePhotos, photoReport } from "./photos";
import ElectricalStandardPdf from "./ElectricalStandardPdf";
import ElectricalElaboratePdf from "./ElectricalElaboratePdf";

/**
 * Turn a report model into a file on the auditor's disk. Ported from
 * Csa/report/exportPdf.js.
 *
 * `pdf(doc).toBlob()` then `saveAs`, rather than react-pdf's
 * PDFDownloadLink — the link's async blob URL is sometimes not ready when
 * the user clicks, and the download silently does nothing.
 */

const LAYOUTS = {
  standard: ElectricalStandardPdf,
  elaborate: ElectricalElaboratePdf,
};

/** `Acme_Ltd_Plant_1_Electrical_2026-08-29.pdf` — sortable, and safe on Windows. */
export function fileNameFor(model, ext) {
  const safe = (s) =>
    String(s || "")
      .replace(/[^A-Za-z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "")
      .slice(0, 40);

  const date = (model.header.end_date || model.header.start_date || "")
    .toString()
    .slice(0, 10);

  return [safe(model.header.organization), safe(model.header.site), "Electrical", date]
    .filter(Boolean)
    .join("_") + "." + ext;
}

/**
 * Render and save. Rendering runs in the browser tab, which is where the
 * auditor already is and where react-pdf is already a dependency. The photo
 * weight that made this risky is handled upstream: the register embeds ~8 KB
 * thumbnails, not the stored images.
 */
export async function exportReportPdf(model, opts = {}) {
  const Renderer = LAYOUTS[model.layout] || LAYOUTS.standard;
  if (!LAYOUTS[model.layout]) {
    console.warn(`Electrical: no renderer for layout "${model.layout}", using standard`);
  }

  // Photographs inlined first: react-pdf cannot authenticate to the API,
  // and reaching S3 from a browser is what failed in the first place.
  const { model: ready, images } = await inlinePhotos(model, opts.photoBytes);

  const blob = await pdf(<Renderer model={ready} />).toBlob();
  const name = opts.fileName || fileNameFor(model, "pdf");
  saveAs(blob, name);
  return { name, bytes: blob.size, photos: photoReport(images) };
}

/** The same document as a blob URL, for an in-page preview. */
export async function previewReportPdf(model, opts = {}) {
  const Renderer = LAYOUTS[model.layout] || LAYOUTS.standard;
  const { model: ready, images } = await inlinePhotos(model, opts.photoBytes);
  let blob;
  try{
    
    blob = await pdf(<Renderer model={ready} />).toBlob();
  } catch (er){
    console.log('Blob creation failed',er)
  }
  // const blob = await pdf(<Renderer model={ready} />).toBlob();
  return { url: URL.createObjectURL(blob), bytes: blob.size, photos: photoReport(images) };
}
